export default __webpack_public_path__ + "static/media/imgCardOffer1.cc9e2f69.jpg";